import React, { useState, useEffect, Fragment } from 'react';
import {
  Row,
  Button,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  Card,
} from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import {
  gAPI_Messenger,
  API_Ingetration_Channels,
  postAPI_Update_Messengers_DisplayOrder,
  gAPI_Messengers_CategoryList,
  gAPI_Search_Business,
} from '../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import no_menues from './../../../../../assets/no_menu.png';
import MessengerListItem from './components/MessengerListItem';
import AddNewMessenger from './components/AddNewMessenger';
import CategoryTag from './components/CategoryTag';
import IntlMessages from '../../../../../helpers/IntlMessages';
import TemplateMessengerButton from './components/TemplateMessengerButton';
import LanguageTabs from '../components/LanguageTabs/LanguageTabs';
import AddonsAndUpsells_image from '../../../../../assets/addons_and_upsells.png';
import guest_book_image from '../../../../../assets/guest_book_image.png';
import ReactDragListView from 'react-drag-listview';
import { List, Typography } from 'antd';
import 'antd/dist/reset.css';
import { TemplateMessengerList } from './components/TemplateMessengerList';
import AutoTranslateModal from './components/AutoTranslateModal';

function Index({ propertyId, locale }) {
  const [selectedLanguage, setSelectedLanguage] = useState(locale);
  const [messengerList, setMessengerList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [visible, setVisible] = useState(false);
  const [orderBy, setOrderBy] = useState({
    column: 'DisplayOrder',
    label: 'Display Order',
  });
  const [search, setSearch] = useState('');
  const [isHostedPage, setIsHostedPage] = useState(false);
  const [allAddonCategoryData, setAllAddonCategoryData] = useState([]);
  const [allMembershipGroupData, setAllMembershipGroupData] = useState([]);
  const [isEditCategory, setIsEditCategory] = useState(false);
  const [productCategory, setProductCategory] = useState([]);
  const [isImportTemp, setIsImportTemp] = useState(false);
  const [allMessengerList, setAllMessengerList] = useState([]);
  const [isAutoTranslateOpen, setIsAutoTranslateOpen] = useState(false);
  const [propertyLanguages, setPropertyLanguages] = useState([]);
  const orderOptions = [
    { column: 'DisplayOrder', label: 'Display Order' },
    { column: 'Title', label: 'Title' },
    { column: 'Type', label: 'Type' },
    { column: 'Status', label: 'Status' },
  ];
  const typeValue = {
    ServiceActivity: 'Information & Action',
    TitleAction: 'Action Only',
  };

  const getDisplayType = (type) => typeValue[type] || type;
  const sortMessengerList = (list, column) => {
    const getType = {
      DisplayOrder: (i) => i.displayOrder ?? 0,
      Title: (i) => i.title ?? '',
      Type: (i) => getDisplayType(i.type),
      Status: (i) => i.status ?? '',
    };

    const getValue = getType[column];

    return [...list].sort((a, b) => {
      const valA = getValue(a).toString().toLowerCase();
      const valB = getValue(b).toString().toLowerCase();
      if (column === 'DisplayOrder') {
        return valA - valB;
      }
      return valA.localeCompare(valB);
    });
  };

  useEffect(() => {
    if (propertyId === undefined || propertyId === null) return;
    LoadData(selectedLanguage);
    let body = {
      channels: ['ServiceStandAlonePage'],
    };
    AxiosAPI({
      method: 'post',
      url: `${API_Ingetration_Channels}?group_id=${getGroupID()}`,
      data: body,
    }).then((res) => {
      const serviceHostedPageIntegration = res.data.filter(
        (k) =>
          k.channel === 'ServiceStandAlonePage' &&
          k.properties !== undefined &&
          k.properties.includes(propertyId)
      );
      if (serviceHostedPageIntegration.length > 0) setIsHostedPage(true);
    });
  }, [propertyId, orderBy, search]);
  const LoadData = (lang) => {
    if (propertyId === undefined || propertyId === null) return;
    setLoading(true);
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_Messenger}?propertyId=${propertyId}&groupId=${getGroupID()}&lang=${lang}&orderBy=&search=`,
    })
      .then((res) => {
        let service = res.data.sort((a, b) => a.displayOrder - b.displayOrder);
        service = sortMessengerList(service, orderBy.column); //sorting
        setMessengerList(service);
        setAllMessengerList(service);
        let member = allMembershipGroupData;
        service.map((m) => {
          if (m.membershipGroup !== null && m.membershipGroup.length > 0)
            m.membershipGroup.map((n) => {
              if (member.filter((f) => f === n).length === 0) member.push(n);
            });
        });
        setAllMembershipGroupData(member);
        setLoading(false);
      })
      .catch((err) => console.log('err', err));

    AxiosAPI({
      method: 'get',
      url: `${gAPI_Messengers_CategoryList}?groupId=${getGroupID()}&propertyId=${propertyId}`,
    }).then((res) => {
      setAllAddonCategoryData(res.data.filter((i) => i.languageCode === lang));
    });

    AxiosAPI({
      methed: 'get',
      url: `${gAPI_Search_Business}/?propertyId=${propertyId}`,
    })
      .then((res) => {
        var list = [];
        res.data.map((l) => {
          list.push({ label: l.categories, value: l.categories });
        });
        setProductCategory(list);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const setLanguage = (e) => {
    setLoading(true);
    var lan = e;
    if (e === 'zh-TW') {
      lan = 'hk';
    }
    setSelectedLanguage(lan);
    LoadData(lan);
    setLoading(false);
  };

  const toggleModal = () => {
    setVisible(!visible);
  };

  // const changeOrderBy = (column) => {
  //   setOrderBy(orderOptions.find((x) => x.column === column));
  // };

  // const onSearchKey = (e) => {
  //   if (e.key === 'Enter') {
  //     setSearch(e.target.value.toLowerCase());
  //   }
  // };
  const changeOrderBy = (column) => {
    const selected = orderOptions.find((x) => x.column === column);
    setOrderBy(selected);

    const sorted = sortMessengerList(allMessengerList, column);
    setMessengerList(sorted);
  };

  const onSearchKey = (e) => {
    if (e.key === 'Enter') {
      const keyword = e.target.value.toLowerCase();
      setSearch(keyword);

      if (keyword === '') {
        // if search box is empty, restore full list
        setMessengerList(allMessengerList);
      } else {
        const filtered = allMessengerList.filter(
          (item) =>
            item.title?.toLowerCase().includes(keyword) ||
            item.displayText?.toLowerCase().includes(keyword) ||
            item.type?.toLowerCase().includes(keyword)
        );
        setMessengerList(filtered);
      }
    }
  };

  if (loading) {
    return <div className="loading" />;
  }
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  const onDragEnd = (fromIndex, toIndex, type, index) => {
    if (toIndex < 0) return;
    if (type === 'LIST-ITEM') {
      const categories = reorder(messengerList, fromIndex, toIndex);
      var data = [];
      categories.map((item, i) => {
        data.push({
          id: item.id,
          displayOrder: i,
        });
      });
      AxiosAPI({
        method: 'post',
        url: `${postAPI_Update_Messengers_DisplayOrder}`,
        data: { data: data },
      })
        .then((res) => {
          return setMessengerList(categories);
        })
        .catch((err) => {
          console.log('err', err);
        });
    } else return new Error('NOT A VALID LIST');
  };

  return (
    <Fragment>
      <Row className="app-row survey-app">
        <Colxx xxs="12">
          <div className="mb-2">
            <h4>
              <b>
                <IntlMessages id="web-widget.title" />
              </b>
            </h4>
            <p>
              A list of the most popular questions and tasks on the Website
              Chatbot, making navigation easier, speeding up task completion,
              and enhancing user experience.
            </p>
          </div>
          <div className="mb-2 mt-4">
            <div className="d-block d-md-inline-block">
              <UncontrolledDropdown className="mr-1 float-md-left btn-group mb-1">
                <DropdownToggle caret color="outline-dark" size="xs">
                  <IntlMessages id="pages.orderby" />
                  {orderBy.label}
                </DropdownToggle>
                <DropdownMenu>
                  {orderOptions.map((order, index) => {
                    return (
                      <DropdownItem
                        key={index}
                        onClick={() => changeOrderBy(order.column)}
                      >
                        {order.label}
                      </DropdownItem>
                    );
                  })}
                </DropdownMenu>
              </UncontrolledDropdown>
              <div className="search-sm d-inline-block float-md-left mr-1 mb-1 align-top">
                <input
                  type="text"
                  name="keyword"
                  id="search"
                  placeholder="Search"
                  onKeyPress={(e) => onSearchKey(e)}
                />
              </div>
              {!loading && (
                <Fragment>
                  <Button
                    color="primary"
                    size="xs"
                    outline
                    className=" mr-1"
                    onClick={toggleModal}
                  >
                    + Add Menu
                  </Button>

                  <Button
                    color="primary"
                    size="xs"
                    outline
                    className="mr-1"
                    onClick={() => setIsImportTemp(true)}
                  >
                    Import From Templates
                  </Button>
                  {/* <Button
                    color="primary"
                    size="xs"
                    className=" mr-1"
                    onClick={() => setIsEditCategory(true)}
                  >{""}<IntlMessages id="survey.edit" /> <IntlMessages id="survey.category" />
                  </Button> */}
                  {/* <TemplateServiceButton LoadData={LoadData} isServiceOrder={false} /> */}
                </Fragment>
              )}

              {locale && locale === 'en' && (
                <a href="/app/pages/propinfo/publish-ai">
                  <Button
                    color="primary"
                    outline
                    className="ml-2"
                    size="xs"
                    style={{ borderRadius: '20px' }}
                  >
                    Publish AI
                  </Button>
                </a>
              )}

              <Button
                color="primary"
                outline
                className="ml-2"
                size="xs"
                style={{ borderRadius: '20px' }}
                onClick={() => setIsAutoTranslateOpen(true)}
              >
                Auto Translate
              </Button>
            </div>
          </div>
        </Colxx>
        <Colxx xxs="12">
          <LanguageTabs
            selectedTab={selectedLanguage === 'hk' ? 'zh-TW' : selectedLanguage}
            setLanguage={setLanguage}
            getPropertyLanguage={(langs) => setPropertyLanguages(langs)}
          ></LanguageTabs>
        </Colxx>
      </Row>
      {/* <Separator className="mb-5" /> */}
      {!loading ? (
        <div>
          {messengerList.length > 0 ? (
            <div>
              <Card
                className="d-flex flex-row "
                style={{
                  borderRadius: '10px',
                  backgroundColor: 'var(--theme-color-2)',
                  marginBottom: '20px',
                }}
              >
                <div className="pl-2 d-flex flex-grow-1 min-width-zero">
                  <div
                    className="card-body align-self-center d-flex flex-column flex-lg-row text-white"
                    style={{ marginTop: '4px' }}
                  >
                    <p className="mb-1 ml-5 text-small font-weight-bold w-18 w-sm-100"></p>
                    <p className="mb-1 text-small font-weight-bold w-15 w-sm-100">
                      Title
                    </p>
                    <p className="mb-1 text-small font-weight-bold w-15 w-sm-100">
                      Type
                    </p>
                    <p className="mb-1 text-small font-weight-bold w-20 w-sm-100">
                      Description
                    </p>
                    <p className="mb-1 text-small font-weight-bold w-12 w-sm-100">
                      Category
                    </p>
                    <p className="mb-1 text-small font-weight-bold w-10 w-sm-100">
                      Status
                    </p>

                    <p className="mb-1 text-small font-weight-bold w-10 w-sm-100"></p>
                  </div>
                </div>
              </Card>
              <ReactDragListView
                nodeSelector=".ant-list.draggable"
                lineClassName="dragLine"
                onDragEnd={(fromIndex, toIndex) =>
                  onDragEnd(fromIndex, toIndex, 'LIST-ITEM')
                }
              >
                {messengerList.map((elem, index) => (
                  <List key={index} className="draggable">
                    <div className="d-flex flex-row mb-3">
                      <span className="draggable item-center mb-3">
                        <a href="#">
                          <i className="simple-icon-cursor-move"></i>
                        </a>
                      </span>
                      <MessengerListItem
                        item={elem}
                        toggleModal={toggleModal}
                        isHostedPage={isHostedPage}
                        isServiceOrder={false}
                        allAddonCategoryData={allAddonCategoryData}
                        allMembershipGroupData={allMembershipGroupData}
                        LoadData={LoadData}
                        languageCode={selectedLanguage}
                        productCategorydata={productCategory}
                      />
                    </div>
                  </List>
                ))}
              </ReactDragListView>
            </div>
          ) : (
            <Fragment>
              <Colxx xxs="12" className="mb-0 text-center">
                <img
                  className="w-25"
                  style={{ marginTop: '5rem' }}
                  src={no_menues}
                ></img>
              </Colxx>
              <Colxx xxs="12" className="mb-4 text-center">
                <Button
                  color="primary"
                  size="xs"
                  outline
                  className=" mr-1"
                  onClick={toggleModal}
                >
                  + Add Your First Menu
                </Button>
              </Colxx>
            </Fragment>
          )}
        </div>
      ) : (
        <div className="loading" />
      )}

      <AddNewMessenger
        toggleModal={toggleModal}
        formLabel="Create"
        visible={visible}
        allAddonCategoryData={allAddonCategoryData}
        allMembershipGroupData={allMembershipGroupData}
        LoadData={LoadData}
        languageCode={selectedLanguage}
        productCategorydata={productCategory}
      />
      {isEditCategory && (
        <CategoryTag
          visible={isEditCategory}
          toggle={() => setIsEditCategory(!isEditCategory)}
          allCategoryData={allAddonCategoryData}
          isEdit={isEditCategory}
          propertyId={propertyId}
          LoadData={LoadData}
          languageCode={selectedLanguage}
        ></CategoryTag>
      )}

      {isImportTemp && (
        <TemplateMessengerList
          toggle={() => setIsImportTemp(false)}
          visible={isImportTemp}
          locale={locale}
          LoadData={LoadData}
          propertyId={propertyId}
          allAddonCategoryData={allAddonCategoryData}
        ></TemplateMessengerList>
      )}

      {isAutoTranslateOpen && (
        <AutoTranslateModal
          isOpen={isAutoTranslateOpen}
          toggle={() => setIsAutoTranslateOpen(false)}
          propertyLanguages={propertyLanguages}
          messengerList={messengerList}
          languageCode={selectedLanguage}
          LoadData={LoadData}
        />
      )}
    </Fragment>
  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId, locale } = settings;
  return {
    propertyId,
    locale,
  };
};

export default injectIntl(connect(mapStateToProps, {})(Index));
